import React, { useState,useEffect } from 'react';
import firebase from './firebase'
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Loading from './Loading';
import './Login.scss';

interface Props {
	uid: string,
    isAuth:boolean,
    login(uid:string):void,
	logout():void,
}

const Login = (props:Props)=> {
	const [isLoading,setIsLoading] = useState(true);

    const login = (event: React.MouseEvent<HTMLElement>)=>{
		if( event.currentTarget.dataset.method ){
			setIsLoading(true);
			if( event.currentTarget.dataset.method==="twitter" ){
				login_with_twitter();
			} else if( event.currentTarget.dataset.method==="google" ){
				login_with_google();
			}
		}
    }
    const logout = ()=>{
		setIsLoading(true);
		firebase.auth().signOut()
		props.logout();
    }

	const login_with_google = ()=>{
		const provider = new firebase.auth.GoogleAuthProvider()
		firebase.auth().signInWithRedirect(provider)
	}

	const login_with_twitter = ()=>{
		const provider = new firebase.auth.TwitterAuthProvider()
		firebase.auth().signInWithRedirect(provider)
	}
    
    useEffect( ()=>{
		firebase.auth().onAuthStateChanged(user => {
			setIsLoading(false);
			if( user ){
				if( !props.isAuth && user.uid!==props.uid ){
					//console.log("login",user);
					props.login && props.login(user.uid);
				}
			}
		});
	},[props]);
	
    return (
        <div id="login">
			{props.isAuth ? (
				<FormControl style={{paddingTop:"2em"}}>
					<Button size="small" variant="outlined" color="primary" onClick={logout}><FontAwesomeIcon icon="sign-out-alt" style={{marginRight:"0.5em"}}/>ログアウト</Button>
				</FormControl>
			) : (
                <FormControl fullWidth={true}>
					<Button size="small" onClick={login} variant="outlined" color="primary" data-method="google" className="loginBtn"><FontAwesomeIcon icon={['fab','google']} style={{marginRight:"0.5em"}}/> Google でログイン</Button>
					<Button size="small" onClick={login} variant="outlined" color="primary" data-method="twitter" className="loginBtn"><FontAwesomeIcon icon={['fab','twitter']} style={{marginRight:"0.5em"}}/> Twitter でログイン</Button>
                </FormControl>
			)}
			<Loading isLoading={isLoading}/>
        </div>
    );
}

export default Login;
